/**
 * La quantita' di una riga dell'export CSV, in kg, con la virgola decimale.
 *
 * **Perche' la virgola.** L'export separa i campi con `;`, la convenzione
 * dell'Excel europeo, e l'import (`ImportModal.vue`) normalizza la virgola al
 * punto, pur continuando ad accettare anche il punto. Con il punto un Excel in
 * italiano divide bene le colonne ma legge `21.5` come testo, e `SOMMA` lo
 * scarta: il totale dei kg usciva contato sui soli interi.
 *
 * Solo il separatore decimale, niente separatore delle migliaia: l'import non
 * lo riconosce, e `1.234` in quella colonna direbbe un altro numero.
 *
 * Il valore salvato e' in centesimi di kg, in una colonna `integer`. Entro quel
 * limite dividere per 100 da' gia' il decimale esatto come stringa piu' corta
 * (`2135 / 100` e' `21.35`), quindi non serve arrotondare.
 */
export const csvQuantity = (storedQuantity) => String(storedQuantity / 100).replace('.', ',');
